// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__27_gm","error":"Textarea_error__2jWhb","readonly":"Textarea_readonly__2xx-R","disabled":"Textarea_disabled__XXFVw"};